// FONT AWESOME
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Regular icons
import {
  faCheckCircle,
  faCheckSquare,
  faCopy,
  faCreditCard,
  faClock,
  faEdit,
  faEye,
  faEyeSlash,
  faFlag,
  faFolderOpen,
  faStickyNote,
  faTimesCircle,
  faTrashAlt,
} from '@fortawesome/free-regular-svg-icons';

library.add(faCheckCircle, faCheckSquare, faCopy, faCreditCard, faClock, faEdit, faEye, faEyeSlash, faFlag, faFolderOpen, faStickyNote, faTimesCircle, faTrashAlt,);

export default FontAwesomeIcon;
